import React, { useState } from 'react';
import styles from './styles';
/**
 * Component for StyledNavLink
 * @component
 * @param  {Object} props Props for component
 * @example
 * <StyledNavLink
 *  styles='OBJECT'
 *  hoverStyles='OBJECT'
 *  to='STRING'
 *  text='STRING'
 * />
 */
const StyledNavLink = (props) => {
  const [hover, setHover] = useState(false);
  const {NavLink} = props;

  const hoverOn = () => setHover(true);
  const hoverOff = () => setHover(false);
  const compiledStyles = {
    ...styles.navLink,
    ...props.styles,
  };
  const compiledHoverStyles = {
    ...styles.navHover,
    ...props.hoverStyles,
  };

  const linkStyles = hover
    ? {
      ...compiledStyles,
      ...compiledHoverStyles,
    }
    : compiledStyles;

  return (
    <NavLink
      isActive={props.callback || null}
      style={linkStyles}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      exact={props.exact}
      to={props.to}
      activeStyle={{ ...compiledStyles, ...props.activeStyles }}
    >
      {props.children || props.text}
    </NavLink>
  );
};

export default StyledNavLink;
